import React from 'react';

const Hero = () => {
  // Simple icon components - monochrome and subtle
  const ToolIcon = ({ children }) => (
    <div className="w-10 h-10 flex items-center justify-center border border-slate-200/60 rounded bg-background text-text-secondary">
      {children}
    </div>
  );

  return (
    <section
      id="hero"
      className="bg-background py-16 md:py-24 px-6 md:px-10"
    >
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-24">
          {/* Left Column - Main Content */}
          <div className="flex flex-col justify-center">
            <h1 className="text-4xl md:text-6xl font-semibold text-text-primary mb-6 tracking-tight leading-tight">
              Technical consulting for modern business systems
            </h1>
            
            <p className="text-lg md:text-xl text-text-secondary mb-8 leading-relaxed max-w-2xl">
              We deliver practical technical solutions that help teams implement, optimize, and maintain reliable business systems.
            </p>
            
            <div className="flex gap-4">
              <button 
                onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
                className="bg-accent text-white px-8 py-3 text-base font-medium hover:opacity-90 transition-opacity"
              >
                Contact
              </button>
              <button 
                onClick={() => document.getElementById('services').scrollIntoView({ behavior: 'smooth' })}
                className="border border-accent/30 text-text-primary px-8 py-3 text-base font-medium hover:bg-soft-surface transition-colors"
              >
                Services
              </button>
            </div>
          </div>

          {/* Right Column - Proof Panel */}
          <div className="lg:flex lg:items-center">
            <div className="bg-soft-surface border border-slate-200/60 p-8 rounded-lg">
              <div className="space-y-8">
                {/* Capabilities */}
                <div>
                  <h3 className="text-sm font-semibold text-text-primary mb-4">Capabilities</h3>
                  <ul className="space-y-2 text-base text-text-secondary">
                    <li>Systems implementation</li>
                    <li>Workflow & integration automation</li>
                    <li>Custom internal tools</li>
                    <li>API & third-party integrations</li>
                    <li>Documentation & training</li>
                  </ul>
                </div>

                {/* Engagement Model */}
                <div className="border-t border-slate-200/60 pt-8">
                  <h3 className="text-sm font-semibold text-text-primary mb-4">Engagement model</h3>
                  <ul className="space-y-2 text-base text-text-secondary">
                    <li>Assessment & system review (1–2 weeks)</li>
                    <li>Solution design & implementation</li>
                    <li>Deployment, documentation, and handoff</li>
                  </ul>
                </div>

                {/* Tooling & Platforms */}
                <div className="border-t border-slate-200/60 pt-8">
                  <h3 className="text-sm font-semibold text-text-primary mb-2">Tooling & Platforms</h3>
                  <p className="text-xs text-text-secondary mb-4">Representative tools used across client environments.</p>
                  <div className="grid grid-cols-3 sm:grid-cols-5 gap-2">
                    {/* HubSpot */}
                    <ToolIcon>
                      <img 
                        src="/icons/hubspot-icon.svg" 
                        alt="HubSpot" 
                        className="w-5 h-5 opacity-60"
                        style={{ filter: 'grayscale(100%) brightness(0) invert(0.4)' }}
                      />
                    </ToolIcon>
                    {/* Salesforce */}
                    <ToolIcon>
                      <img 
                        src="/icons/salesforce-icon.svg" 
                        alt="Salesforce" 
                        className="w-5 h-5 opacity-60"
                        style={{ filter: 'grayscale(100%) brightness(0) invert(0.4)' }}
                      />
                    </ToolIcon>
                    {/* Airtable */}
                    <ToolIcon>
                      <img 
                        src="/icons/airtable-icon.svg" 
                        alt="Airtable" 
                        className="w-5 h-5 opacity-60"
                        style={{ filter: 'grayscale(100%) brightness(0) invert(0.4)' }}
                      />
                    </ToolIcon>
                    {/* Slack */}
                    <ToolIcon>
                      <img 
                        src="/icons/slack-icon.svg" 
                        alt="Slack" 
                        className="w-5 h-5 opacity-60"
                        style={{ filter: 'grayscale(100%) brightness(0) invert(0.4)' }}
                      />
                    </ToolIcon>
                    {/* Zapier - Full icon */}
                    <ToolIcon>
                      <img 
                        src="/icons/zapier-icon.svg" 
                        alt="Zapier" 
                        className="w-5 h-5 opacity-60"
                        style={{ filter: 'grayscale(100%) brightness(0) invert(0.4)' }}
                      />
                    </ToolIcon>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
